export default "__VITE_ASSET__CapzHTfk__"